export const NORMAL_QUESTION = 'normal';
export const TIME_BASE_QUESTION = 'time_based';
export const ALL_QUESTION = 'all';



// WEBPACK FOOTER //
// ./src/constants/questionType.js